<div class="summary-overview-container">
	<span class="summary-overview-title">
		{{ "using_cash_plus_balance" | translate }}
	</span>
	<div class="summary-overview-values">
		<div class="summary-overview-col">
			<span class="overview-value-title">
				{{ "fiat_wallet_balance" | translate }}
			</span>
			<span class="font-bold">
				{{
					(!isLessThanAmount ? +offer.getAmountFiat() : +vm?.availableAssetBalance)
						| fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat], symbol: true }
				}}
			</span>
		</div>
		<div class="summary-overview-col">
			<span class="overview-value-title">
				{{ "cash_plus_wallet_balance" | translate }}
			</span>
			<span class="font-bold">
                {{
                    calculateFiatValue(
                        isLessThanAmount,
                        vm?.parkedAssetBalance,
                        vm?.assetBalance,
                        +offer.getAmountFiat()
                    )
                        | fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat], symbol: true }
                }}
			</span>
		</div>
		<div class="summary-overview-col">
			<span class="overview-value-title">
				{{ "cash_plus_balance_left" | translate }}
			</span>
			<span class="font-bold">
				{{
					(+vm.parkedAssetBalance - +offer.getAmountFiat() > 0 ? +vm.parkedAssetBalance - +offer.getAmountFiat() : 0)
						| fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat], symbol: true }
				}}
			</span>
		</div>
	</div>

	<ng-content></ng-content>
</div>
